import { SELF_PERSPECTIVE_KEY, type Perspective } from './perspective'
import { FeedbackPerspective } from './feedback-perspective'

export const perspectiveKeyOf = (perspective: Perspective | string): string =>
  typeof perspective === 'string' ? perspective : perspective.key

/**
 * Temporary map from topic perspective keys → dialog-task `numberOf*` fields.
 * Dialog topic tasks still use the three legacy count fields (handover 3 §5).
 */
export const legacyTaskCountFieldForPerspective = (
  perspective: Perspective | string,
): 'numberOfSelfFeedbacks' | 'numberOfPeerFeedbacks' | 'numberOfExternalFeedbacks' => {
  const key = perspectiveKeyOf(perspective)
  if (key === SELF_PERSPECTIVE_KEY || key === FeedbackPerspective.Self) {
    return 'numberOfSelfFeedbacks'
  }

  if (typeof perspective !== 'string' && perspective.legacyMethod === 'peer') {
    return 'numberOfPeerFeedbacks'
  }
  if (typeof perspective !== 'string' && perspective.legacyMethod === 'external') {
    return 'numberOfExternalFeedbacks'
  }

  if (key === 'peers' || key === FeedbackPerspective.Peer || key === 'peer') {
    return 'numberOfPeerFeedbacks'
  }

  return 'numberOfExternalFeedbacks'
}
